const UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  FormatMoney(cents) {
    let MoneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: "USD",
    });
    return MoneyFormatter.format(cents / 100);
  },
  async AddItemsToCart (items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  async UpdateCartItems(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  async UpdateCartItem(item) {
    if (!item) return;

    // /cart/change.js returns the full updated cart JSON. Parse it so callers
    // can use the response directly instead of firing a follow-up GET /cart.js
    // (saves ~300–500ms per quantity change / upsell swap).
    return await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }).then(res => res.json());
  },
  async GetCart() {
    return await fetch('/cart.js').then(res => res.json());
  },
  // Delivery interval in months parsed from a selling plan name, e.g.
  // "Every 3 months (Buy 2, Get 1 Free)" -> 3. Only the number directly
  // before "month" counts, so marketing text in the name can't change it.
  PlanMonths(plan) {
    let m = plan && plan.name ? String(plan.name).match(/(\d+)\s*-?\s*months?\b/i) : null;
    return m ? parseInt(m[1], 10) : null;
  },
  GetVariantSellingPlan(product, variant, plan_id) {
    if (!product || !variant || !plan_id) return;

    let plan = product.all_selling_plans.find(item => item.id == plan_id);
    if (!plan) return;

    let price_adjustment_type = plan.price_adjustments[0].value_type;
    let plan_price;
    if (price_adjustment_type == 'percentage') {
      plan_price = (variant.price * (100 - plan.price_adjustments[0].value)) / 100;
    }
    else {
      plan_price = plan.price_adjustments[0].value;
    }
    plan.price = plan_price;

    let months = UTILS.PlanMonths(plan);
    let plan_display_name = plan.name;
    if (months === 1) plan_display_name = 'Monthly Plan';
    if (months === 3) plan_display_name = '3 Month Plan';
    plan.display_name = plan_display_name;
    plan.months = months;

    let is_quarter = false;
    if (months === 1) {
      plan.prefix = 'paid monthly';
    }
    if (months === 3) {
      is_quarter = true;
      plan.prefix = 'paid quarterly';
    }

    plan.price_per_month = is_quarter ? (plan.price / 3) : plan.price;

    // saving calculation
    let price_to_compare = variant.price;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      price_to_compare = variant.compare_at_price;
    }
    let savings = ((price_to_compare - plan_price) / variant.price) * 100;
    plan.savings = `${ savings.toFixed(0) }%`;

    // Stable key ("3-pack--every-3-months") used by CSS, the BEST VALUE pill,
    // quarterly preselect and upsell matching. Built from the interval, not
    // the raw name, so renaming a plan in the subscription app can't break it.
    let plan_key = months ? `every ${ months } month${ months === 1 ? '' : 's' }` : plan.name;
    plan.identifier = `${ variant.title }--${ plan_key }`.toLowerCase().replaceAll(' ', '-');
    // console.log(product.all_selling_plans, plan_id, plan)
    return plan; 
  },
  ObserveCartRequests() {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.name.indexOf('/cart/') !== -1) {
          // console.log(entry)
          document.dispatchEvent(new CustomEvent('cart:modified', {detail: {entry}}));
        }
      }
    });
    
    observer.observe({
      entryTypes: ["resource"]
    });    
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });  
  },
  async FormSubmitAjax(form) {
    let response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
    if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
    return response;
  },
  Convert2JSON(json) {
    return JSON.parse(JSON.stringify(json));
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductForm_v1', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      // Allow opting into a variant section (e.g. product-form-v1b) via data attribute on the loader element. Defaults to v1 for back-compat.
      let section_id = am.$el.dataset.sectionId || 'product-form-v1';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  // A/B variant of ProductForm_v1. Same loader logic; defaults to fetching the v1b section instead of v1. Disposable once the A/B test picks a winner.
  Alpine.data('ProductForm_v1b', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = am.$el.dataset.sectionId || 'product-form-v1b';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  // A/B variant of ProductForm_v1. Same loader logic; defaults to fetching the v1c section instead of v1. Disposable once the A/B test picks a winner.
  Alpine.data('ProductForm_v1c', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = am.$el.dataset.sectionId || 'product-form-v1c';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

Alpine.data('CustomProductForm_V1', (product) => ({
  product: product,
  cache: {},
  quantity: 1,
  purchaseType: 'subscribe',
  current_selling_plan: null,
  current_variant: null,
  // Reactive pending flag toggled around the e_AddToCart async work.
  // Both buy buttons read it to swap their label + disable themselves so
  // the click feels acknowledged immediately, even when the cart-add +
  // checkout redirect takes a beat (mobile / slow network).
  pending: false,

  init() {
    let am = this;
    am.InitSelf();
    am.InitWatchers();
  },

  InitSelf() {
    let am = this;
    am.cache.$formWrap = am.$el.closest('.product-form-wrap');

    // Hide skeleton once Alpine is ready
    let skeleton = am.$el.previousElementSibling;
    if (skeleton && skeleton.classList.contains('form-skeleton')) {
      skeleton.style.display = 'none';
    }

    am.quantity = 3;
    am.current_variant = am.GetCurrentVariant();
    am.current_selling_plan = am.GetSubscriptionPlan();
  },

  InitWatchers() {
    let am = this;
    am.$watch('current_variant', () => {
      am.product.current_variant = am.current_variant;
      am.quantity = am.GetQuantityFromVariant(am.current_variant);
      am.current_selling_plan = am.GetSubscriptionPlan();
    });
  },

  FormatMoney(cents) {
    return UTILS.FormatMoney(cents);
  },

  GetQuantityFromVariant(variant) {
    if (!variant) return 1;
    let match = variant.title.match(/(\d+)\s*Pack/i);
    return match ? parseInt(match[1]) : 1;
  },

  GetMonthLabel(qty) {
    return qty === 1 ? '1 Month' : `${qty} Months`;
  },

  GetCurrentVariant() {
    let am = this;
    return am.product.variants.find(v => v.title.includes(`${am.quantity} Pack`))
      || am.product.variants[0];
  },

  GetSubscriptionPlan() {
    let am = this;
    let variant = am.current_variant || am.GetCurrentVariant();
    let plan_id = am.product.selling_plan_groups[0].selling_plans[0].id;
    return variant.selling_plan_allocations.find(a => a.selling_plan_id === plan_id)
      || variant.selling_plan_allocations[0];
  },

  GetPerDay(variant, qty) {
    let am = this;
    if (!variant) return '';
    const DAYS_PER_BOTTLE = 30;
    let allocation = variant.selling_plan_allocations[0];
    if (!allocation) return '';
    return am.FormatMoney(Math.round(allocation.per_delivery_price / (qty * DAYS_PER_BOTTLE)));
  },

  // Per-day based on one-time price — used on the one-time purchase link only
  GetPerDayOneTime(variant, qty) {
    let am = this;
    if (!variant) return '';
    const DAYS_PER_BOTTLE = 30;
    let totalDays = qty * DAYS_PER_BOTTLE;
    return am.FormatMoney(Math.round(variant.price / totalDays));
  },

  // Anchor price for strike/savings: compare_at_price when it is a real
  // markdown (> price), otherwise the variant's one-time price.
  GetAnchorPrice(variant) {
    let am = this;
    let v = variant || am.current_variant;
    if (!v) return 0;
    let compare = Number(v.compare_at_price) || 0;
    let price = Number(v.price) || 0;
    return compare > price ? compare : price;
  },

  // Subscription savings in cents vs the anchor (never negative).
  GetSubSavingsAmount() {
    let am = this;
    if (!am.current_variant || !am.current_selling_plan) return 0;
    let diff = am.GetAnchorPrice(am.current_variant) - am.current_selling_plan.per_delivery_price;
    return diff > 0 ? diff : 0;
  },

  GetSavingsPercent() {
    let am = this;
    let anchor = am.GetAnchorPrice(am.current_variant);
    let savings = am.GetSubSavingsAmount();
    if (!anchor || savings <= 0) return 0;
    return Math.round(savings / anchor * 100);
  },

  GetSavings(variant, qty) {
    let am = this;
    if (!variant) return { savings: 0, savings_money: '' };
    let anchor = am.GetAnchorPrice(variant);
    let savings = anchor - variant.price;
    if (am.purchaseType == 'subscribe' && am.current_selling_plan) {
      savings = anchor - am.current_selling_plan.per_delivery_price;
    }
    if (savings < 0) savings = 0;
    return {
      savings: savings,
      savings_money: `Save ${am.FormatMoney(savings)}`
    };
  },

  async e_AddToCart() {
    let am = this;
    // Guard against double-clicks. If pending is already true, the
    // previous click is still in flight — ignore subsequent clicks
    // so we don't submit the form twice (which would add 2× quantity
    // to the cart on slow networks).
    if (am.pending) return;
    am.pending = true;
    // Let Alpine apply the purchaseType change (x-if adds/removes the
    // selling_plan input) BEFORE we serialize the form — otherwise a One-Time
    // click still POSTs the stale subscription selling_plan. See OTP bug.
    await am.$nextTick();
    let $form = am.$el.closest('.custom-product-atc-form');
    // Opt-in: forms tagged with data-redirect-to-checkout go straight to
    // checkout in the SAME window after the cart-add resolves. Previous
    // behavior opened a new tab via window.open('about:blank', '_blank');
    // changed 2026-05-19 because: (a) cold-traffic friction — leaving
    // the LP in the browser back-stack adds confusion; (b) the new tab
    // path conflicted with the upgrade-modal intercept on the v2 LP.
    let redirectToCheckout = $form && $form.dataset.redirectToCheckout === 'true';

    try {
      await UTILS.FormSubmitAjax($form);
      // M1 free-shipping intercept, buy-box path. Only ONE-TIME adds are
      // eligible, and window.lpBumpMaybeShow only exists on LP pages whose
      // sticky snippet was given a bump_discount_code — everywhere else
      // (PDPs included) this is inert. When the modal takes over, decline
      // resolves to this surface's own default flow.
      if (am.purchaseType === 'one-time' && typeof window.lpBumpMaybeShow === 'function') {
        let $vid = $form.querySelector('[name="id"]');
        // Review finding 4: a multi-quantity add breaks the modal's one-bottle
        // math and is usually over the free-shipping threshold anyway. Skip.
        let $qty = $form.querySelector('[name="quantity"]');
        if ($qty && parseInt($qty.value, 10) > 1) {
          if (typeof window.lpStampVariant === 'function') window.lpStampVariant();
        } else {
        let proceed = redirectToCheckout
          ? () => { window.location.href = '/checkout'; }
          : () => {
              document.dispatchEvent(new Event('cart:modified'));
              document.dispatchEvent(new Event('cart:drawer:open'));
              am.pending = false;
            };
        if (typeof window.lpStampVariant === 'function') window.lpStampVariant();
        if ($vid && window.lpBumpMaybeShow(String($vid.value), null, proceed)) {
          document.dispatchEvent(new Event('cart:modified'));
          am.pending = false;
          return;
        }
        }
      }
      if (redirectToCheckout) {
        // Deliberately leave am.pending = true so the button stays in its
        // loading state until the browser navigates away. Resetting to
        // false here would briefly flash the button back to its normal
        // label before the page unloads — looks like the click failed.
        window.location.href = '/checkout';
        return;
      }
      document.dispatchEvent(new Event('cart:modified'));
      document.dispatchEvent(new Event('cart:drawer:open'));
      am.pending = false;
    } catch (err) {
      am.pending = false;
      throw err;
    }
  },

}));


  Alpine.data('ProductForm_v2', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = 'product-form-v2';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  Alpine.data('CustomProductForm_V2', (product) => ({
    product: product,
    cache: {},
    flags: {
      variant_picker: false,
      add_upsell: false
    },
    computed: {
      selling_plans: [],
      current_variant_plans: []  
    },
    selected: {
      purchaseOption: '',
      selling_plan: null
    },
    selected_upsell: {
      product: null,
      variant: null,
      purchaseOption: '',
      selling_plan: null
    },
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
      am.SetComputed();
      setTimeout(am.ToggleUpsells.bind(am), 0);

      if (am.flags.preselect_quarterly) {
        am.$nextTick(() => {
          let $quarterly = am.$el.querySelector('.main-product-wrap [data-identifier="3-pack--every-3-months"]');
          if ($quarterly) $quarterly.dispatchEvent(new Event('click', {bubbles: true}));
        }, 0);
      }  

      // If variant changed
      am.$el.closest('.product-form-wrap').addEventListener('variant-change', (e) => {
        // /console.log(e);
        let $target = e.detail.e.target;
        let option_name = $target.getAttribute('name');
        let option_value = $target.value;
        let option = am.product.options_with_values.find(o => o.name == option_name);
        let option_id = `option${ option.position }`;
        let variant = am.product.variants.find(v => v[option_id] == option_value);
        am.product.current_variant = variant;
        am.$nextTick(am.SetComputed.bind(am));
        // debugger;
      });
    },
    InitSelf() {
      let am = this;
      am.cache.$formWrap = am.$el.closest('.product-form-wrap');
      am.flags.variant_picker = am.cache.$formWrap.dataset.variant_picker == 'true';

      let quarterlyDefault = am.cache.$formWrap.dataset.quarterlyDefault;
      am.flags.preselect_quarterly = quarterlyDefault ? JSON.parse(quarterlyDefault) : false;
    },
    InitWatchers() {
      let am = this;
      // watch selling plan
      am.$watch('selected.purchaseOption', () => {
        am.$nextTick(() => {
          if (am.flags.variant_picker) {
            am.selected.selling_plan = am.computed.current_variant_plans.find(item => item.id == am.selected.purchaseOption);
          }
          else {
            let $selected = am.cache.$formWrap.querySelector('[name="purchaseOption"]:checked');
            let variant_id = $selected.dataset.variant;
            let variant = am.product.variants.find(v => v.id == variant_id);
            am.cache.$formWrap.querySelector('[name=id]').value = variant_id;
            let selling_plan_id = $selected.value;
            am.selected.selling_plan = am.GetPlan(am.product, variant, selling_plan_id);            
          }

          setTimeout(am.ToggleUpsells.bind(am), 0);
        });
      });

      // after upcart add to cart, add upsells
      document.addEventListener('form:added-to-cart', (e) => {
        if (!am.flags.add_upsell) return;

        // Add Upsell item
        (async() => {
          let selling_plan = am.selected.purchaseOption !== 'one-time' ? am.selected_upsell.variant.selling_plan_allocations[0].selling_plan_id : null;
          let items_to_add = [{
            quantity: 1,
            id: am.selected_upsell.variant.id,
            selling_plan: selling_plan,
            properties: {}
          }];
          console.warn('Adding upsell item to cart', items_to_add);
          await UTILS.AddItemsToCart(items_to_add);
          document.dispatchEvent(new CustomEvent('cart:modified'));
        })();
      });
    },
    SetComputed() {
      let am = this;
      am.computed.selling_plans = am.product.selling_plan_groups.flatMap(g => g.selling_plans);

      let current_variant_plans = am.computed.selling_plans.filter((item) => {
        return am.product.current_variant.selling_plan_allocations.map(a => a.selling_plan_id).join('|').indexOf(item.id) !== -1;
      });
      // filter out plans that are not 1 or 3 months
      current_variant_plans = current_variant_plans.filter(plan => [1, 3].includes(UTILS.PlanMonths(plan)));

      am.computed.current_variant_plans = current_variant_plans;
      am.computed.current_variant_plans.forEach((plan) => {
        plan = am.GetPlan(am.product.current_variant, plan.id);
      });

      let plan_monthly = am.computed.current_variant_plans.find(plan => UTILS.PlanMonths(plan) === 1);
      am.selected.purchaseOption = plan_monthly ? plan_monthly.id : 'one-time';
    },
    GetPlan(product, variant, plan_id) {
      return UTILS.GetVariantSellingPlan(product, variant, plan_id); 
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    ToggleUpsells() {
      let am = this;
      let $upsells = am.$el.querySelector('.upsells-wrap');
      if (!$upsells) return;

      let $selected = am.cache.$formWrap.querySelector('[name="purchaseOption"]:checked');
      let $identifier = $selected.closest('[data-identifier]');
      if (!$identifier) return;
      let id = $identifier.dataset.identifier;
      $upsells.querySelectorAll('[data-identifier]').forEach(($item) => {
        $item.classList.add('hidden');
      });

      let $matching_upsell = $upsells.querySelector(`[data-identifier="${id}"]`);
      if ($matching_upsell) {
        $matching_upsell.classList.remove('hidden');
        $upsells.classList.remove('hidden');

        if (am.flags.add_upsell) {
          $matching_upsell.dispatchEvent(new Event('click', {bubbles: true}));
        }
      }
    },
    e_SelectUpsell(product, variant, plan_id) {
      let am = this;
      am.flags.add_upsell = !am.flags.add_upsell;
      am.selected_upsell.product = product;
      am.selected_upsell.variant = am.flags.add_upsell ? variant : null;
    },
    async e_AddToCart(e) {
      e.preventDefault();
      let $product_form = e.target.closest('.custom-product-atc-form');
      await UTILS.FormSubmitAjax($product_form);
      document.dispatchEvent(new CustomEvent('form:added-to-cart'));
      document.dispatchEvent(new Event('cart:modified'));
      document.dispatchEvent(new Event('cart:drawer:open'));
    }
  }));

  Alpine.data('ProductForm_v3', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = 'product-form-v3';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  Alpine.data('CustomProductForm_V3', (product) => ({
    product: product,
    cache: {},
    quantity: 1,
    purchaseType: 'subscribe',
    current_selling_plan: null,
    current_variant: null,
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.cache.$formWrap = am.$el.closest('.product-form-wrap');
      am.flags.variant_picker = am.cache.$formWrap.dataset.variant_picker == 'true';

      am.current_variant = am.GetCurrentVariant();
      am.current_selling_plan = am.GetSubscriptionPlan();
    },
    InitWatchers() {
      let am = this;
      am.$watch('quantity', () => {
        let current_variant = am.GetCurrentVariant();
        am.current_variant = current_variant;
        am.product.current_variant = current_variant;
        am.current_selling_plan = am.GetSubscriptionPlan();
      });
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    GetCurrentVariant() {
      let am = this;
      let variant = am.product.variants.find(v => v.title.includes(`${am.quantity} Pack`));
      return variant;
    },
    GetSubscriptionPlan() {
      let am = this;
      let variant = am.GetCurrentVariant();
      let selling_plans = am.product.selling_plan_groups[0].selling_plans.filter(item => UTILS.PlanMonths(item) === Number(am.quantity)) || am.product.selling_plan_groups[0].selling_plans[0];
      let selling_plan = variant.selling_plan_allocations.find(item => selling_plans.map(p => p.id).includes(item.selling_plan_id)) || variant.selling_plan_allocations[0];
      return selling_plan;
    },
    async e_AddToCart(e) {
      e.preventDefault();
      let $product_form = e.target.closest('.custom-product-atc-form');
      await UTILS.FormSubmitAjax($product_form);
        // First click triggers test participation
        const straightToCheckout = await window.shoplift.isHypothesisActive('019b011c-0329-796d-a94d-cc6d3e401f2b');
  
        if (straightToCheckout) {
           window.location.href = '/checkout';
        } else {
      document.dispatchEvent(new CustomEvent('form:added-to-cart'));
      document.dispatchEvent(new Event('cart:modified'));
      document.dispatchEvent(new Event('cart:drawer:open'));
        }
    }
  }));
});

/* Supplement Facts modal — global delegated open/close. Mirrors the inline
   handler in snippets/product-form-v1-body.liquid so it also works for markup
   that is AJAX-injected (e.g. the product-form-v1c loader), where inline
   <script> tags never execute. Guarded so it inits once per page even if the
   inline version is also present. */
(function() {
  if (window._semaineSuppfactsModalInit) return;
  window._semaineSuppfactsModalInit = true;
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-suppfacts-target]');
    if (trigger) {
      e.preventDefault();
      var dialog = document.getElementById(trigger.dataset.suppfactsTarget);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }
    var closeBtn = e.target.closest('[data-suppfacts-close]');
    if (closeBtn) {
      var d = closeBtn.closest('dialog');
      if (!d) return;
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
      return;
    }
    if (e.target.matches && e.target.matches('.product-suppfacts-modal')) {
      if (typeof e.target.close === 'function') e.target.close();
      else e.target.removeAttribute('open');
    }
  });
})();
